import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ChangeCompanyModal } from '../modals/change-company-modal/change-company-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PracticeService } from '../../services/practice.service';
import { ActionService } from '../../services/action.service';
import { LibService } from '../../services/libService';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
    selector: 'app-practice-change-company',
    templateUrl: './practice-change-company.component.html',
    styleUrls: ['./practice-change-company.component.scss']
})
export class PracticeChangeCompanyComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() companies: any[] = [];

    actionName: any = 'actions_can_change_the_location_of_the_practice'

    constructor(
        private dialog: MatDialog,
        private libService: LibService,
        private practiceService: PracticeService,
        private actionService: ActionService,
    ) { }

    ngOnInit(): void {
        console.log('ngOnInit practice change company')
    }

    openChangeCompanyEdit() {

        let dataStructure: any = {
        }

        const dialogRef = this.dialog.open(ChangeCompanyModal, {
            width: '400px',
            data: dataStructure,
            scrollStrategy: new NoopScrollStrategy(),
        });

        dialogRef.afterClosed().subscribe(result => {
            if (![null, undefined].includes(result)) {

                let practiceId = this.form?.get('PracticeId')?.value
                let company = result.company

                this.libService.lockPage('');

                this.practiceService.changeCompany(practiceId, company.id).subscribe((res: any) => {
                    // ricarica la pratica e i dati. oppure forza il reload della pagina
                    this.libService.unlockPage();
                    window.location.reload();
                })

            }

        });
    }

    checkPermissions(key: string) {
        return this.actionService.checkPermissions(key)
    }

}
